// [ai] /chat: the full conversation on the same store and socket as the dock — a sessions rail on the left (≥ 1100 px; a sheet
// button below), the transcript, the composer at the bottom. ?persona= and ?session= pick the thread on arrival.
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { fullHref, personaOf, useChat } from "../stores/chat";
import { Composer, SessionsList, Transcript, useAstra } from "../chat/ChatUI";
import { usePageTitle } from "./common";

export function ChatPage() {
  const a = useAstra(); const [params] = useSearchParams(); const navigate = useNavigate(); const persona = useChat(personaOf); const cfg = useChat(s => s.cfg); const offline = useChat(s => s.offline); const session = useChat(s => s.session); const hint = useChat(s => s.cfg?.hint ?? ""); const href = useChat(fullHref);
  const [rail, setRail] = useState(false);
  usePageTitle(persona ? `${persona.title} · Astra` : "Astra");
  useEffect(() => {
    void a.load().then(async () => {
      const p = params.get("persona"), s = params.get("session");
      if (p && p !== a.state.persona) await a.setPersona(p);
      if (s && s !== a.state.session && /^[A-Za-z0-9_-]{1,80}$/.test(s)) await a.openSession(s);
      a.collapse();
    });
  }, [a, params]);
  const loaded = useChat(s => !!s.cfg);
  useEffect(() => { if (loaded && href !== location.pathname + location.search) void navigate(href, { replace: true }); }, [href, loaded, navigate]);   // the URL names the thread (a reload or a share lands on it; New chat drops it) — through the router, so every hook agrees
  if (cfg && !cfg.configured) return <section className="at-page"><p className="at-eyebrow">Astra</p><h1>Chat</h1><p className="at-empty">The chat backend is not configured on this server.</p></section>;
  return (
    <div className={"at-chat-page" + (rail ? " rail-open" : "")}>
      <aside className="at-chat-rail" aria-label="Conversations">
        <div className="at-astra-side-h"><span>{persona?.title ?? "Astra"}</span><span className="at-astra-side-hb"><button type="button" className="at-astra-side-new" onClick={() => a.newChat()}>New chat</button></span></div>
        <SessionsList />
        <p className="at-chat-personas">{cfg?.personas.map(p => <button key={p.name} type="button" className={"at-chip" + (p.name === persona?.name ? " on" : "")} onClick={() => void a.setPersona(p.name)} title={p.blurb}>{p.emoji} {p.title}</button>)}</p>
      </aside>
      <section className="at-chat-main" aria-label="Astra conversation">
        <div className="at-chat-head"><button type="button" className="at-btn at-chat-rail-btn" aria-expanded={rail} onClick={() => setRail(r => !r)}>Conversations</button><span className="at-chat-title">{persona?.emoji} {persona?.title}</span></div>
        <Transcript onAnswer={(id, d) => a.answer(id, d)} empty={persona ? `${persona.blurb} Ask anything.` : undefined} />
        {offline ? <p className="at-astra-off">Astra is offline. {hint ? <>Start the chat service: <code>{hint.replace(/^start it with /, "")}</code></> : null}</p> : null}
        <div className="at-chat-row"><Composer variant="page" /></div>
      </section>
    </div>
  );
}
